<template lang="pug">
  #signUpIndex.p-0
    .top
    .container-width.p-3
      #step1(v-if="nowStep == 1")
        .container
          .declare.shadow.border-black
            .declare_wrap
              .declare_text
                p.text-center 美容顧問  One-On-One員工使用規範
                p 為向台灣萊雅之顧客提供更即時且正確之產品及服務訊息，台灣萊雅股份有限公司（下稱「台灣萊雅」）向員工提供即時通訊工具-- 美容顧問  One-On-One( 下稱 「本APP」)，以利於產品及服務資訊之整合，並藉由顧客與美容顧問間之帳號綁定，提供即時之產品及服務諮詢。為此，針對本APP之使用訂定員工使用規範如下：
                  br
                  br
                  | 1. 本APP所內含或接收之所有數據、訊息均屬台灣萊雅之資產。為此，您瞭解且同意對於因使用本APP所取得之一切訊息應予以保密。未經台灣萊雅事前書面同意，您不得將相關訊息以任何方式洩露或公開給任何第三人，或為執行業務目的以外之使用。
                  br
                  br
                  | 2. 為確保資訊之正確性及合法性，您瞭解且同意使用本APP進行本APP之內容管理、向客戶提供產品或服務之行銷資訊、諮詢或提供其他服務（例如：護膚體驗預約）時，僅得使用台灣萊雅所提供之廣告素材或說明文件，並依照台灣萊雅之指示使用方式進行使用。您不得在未經台灣萊雅事前書面同意之情況下，對於前揭廣告素材或說明文件之內容任意改作、編輯或變更其使用方式。
                  br
                  br
                  | 3. 您瞭解且同意於使用本APP進行管理或提供服務時，仍應遵守包括但不限於，台灣萊雅所發布之員工手冊、個人資料檔案安全管理辦法、隱私權政策及台灣萊雅美妝分公司員工手冊或其他相關公告或政策，亦不得有其他可能損及台灣萊雅及其關係企業所屬品牌形象或商譽之行為。
                  br
                  br
                  | 4. 您瞭解且同意對於用於登入本APP之帳號及密碼僅供您個人為執行業務之目的進行使用，非經台灣萊雅事前書面同意，不得提供予第三人（無論是否同屬台灣萊雅員工）使用。
                  br
                  br
                  | 5. 鑒於台灣萊雅已提供本APP作為與顧客間之即時通訊工具，您瞭解且同意不得為執行業務之目的，以您個人所屬之即時通訊軟體帳號與顧客進行聯繫。此外，台灣萊雅得基於包括但不限於商業策略、員工或公司權益保護之考量，選擇開放或取消特定員工全部或部分功能之使用權限、亦得指定所綁定之顧客帳號，或就已綁定之客戶進行變更，員工不得異議。
                  br
                  br
                  | 6. 您瞭解且同意，除經台灣萊雅事前同意之加班情況外，若您於非工作時間登入本APP，視為您自行登入本APP查詢相關內容，該查詢在任何情況下不應視為執行業務或加班。為此，您瞭解且同意，您不得就您個人於非工作期間查詢之活動，向公司請求任何形式之補償或賠償。
                  br
                  br
                  | 7. 若有違反本使用條款及細則之情形者，台灣萊雅得不經通知終止您的使用權限。
            label.btn.btn-ib.btn-custom
              input#checkbox-agree(type='checkbox' name='declare-agree' v-model="agree_status")
              .input_wrap
                .input_icon.border-black
                span.input_text 我同意

          .caption
            span 請填寫以下美容顧問綁定資訊

          ValidationObserver(
            ref="userForm"
            tag="form"
            @submit.stop.prevent="submitHandler"
          )
          .advisor_info
            input(
              type="text",
              name="cn_last_name",
              id="cn_last_name",
              class="input_half",
              v-model="chinese_last_name",
              placeholder="請輸入中文姓氏")

            input(
              type="text",
              name="cn_first_name",
              id="cn_first_name",
              class="input_half",
              v-model="chinese_first_name",
              placeholder="請輸入中文名字")

            input(
              type="text",
              name="preferred_name",
              id="preferred_name",
              class="input_half",
              v-model="preferred_name",
              placeholder="請輸入顯示名字")

            input(
              type="text",
              name="staff_id",
              id="staff_id",
              class="input_half",
              v-model="sa_code",
              placeholder="請輸入員工編號")

          .btn_wrap
            a.btn.btn-b.btn-custom(@click="submitHandler()")
             span 下一步
    .popup#pop-info
      .popup_wrap
        .popup_content.border-black
          .popup_header
            .popup_header_title {{ popup_info }}
          .popup_footer
            .btn_wrap
              a.btn.btn-b.btn-custom(href="javascript:;" @click.stop.prevent='closeModalHandler')
                span 確認

    .popup#wrong-info
      .popup_wrap
        .popup_content.border-black
          .popup_header
            .bind_icon_wrap.shadow-btn.border-black
              .bind_icon.bind_icon-fail
            h1.bind_title
              span 查無符合資料!
            .bind_text
              p 查無符合資料，查無符合資料，查無符合資料，查無符合資料，查無符合資料！
          .popup_footer
            .btn_wrap
              a.btn.btn-b.btn-custom(href="javascript:;" @click.stop.prevent='closeWrongInfoModalHandler')
                span 確認
</template>

<script>
import StepComponent from '@/components/step/StepComponent.vue'; // 客製化進度條
import { ValidationProvider, ValidationObserver, extend } from 'vee-validate'; // 檢查套件
import { required } from 'vee-validate/dist/rules';
import VerifyComponent from '@/components/verify/VerifyComponent.vue'; // 驗證套件
import { SA_SIGN_UP_SUCCESS } from '@/router/sa/sign-up';
import JQuery from 'jquery';

const $ = JQuery;

// 獲取所有驗證條件
extend('required', {
  ...required,
  message: '此欄不可為空'
});

// 客製化身分證驗證
extend('mobile', {
  validate: (val) => {
    const MobileReg = /^(09)[0-9]{8}$/;
    return MobileReg.test(val);
  },
  message: '行動電話格式錯誤'
});

// 客製化驗證套件
extend('verify', {
  validate: (val) => {
    if (VerifyComponent.data.varifyAnswer === undefined) return true;
    return val === VerifyComponent.data.varifyAnswer ? true : false;
  },
  message: '驗證碼錯誤'
});

export default {
  name: 'SaSignUpIndex',
  components: {
    StepComponent,
    ValidationProvider,
    ValidationObserver,
    VerifyComponent
  },
  data() {
    return {
      stepArr: [
        { title: '簽署同意書' },
        { title: '輸入手機號碼' },
        { title: '手機簡訊驗證' },
        { title: '輸入個人資料' }
      ],
      nowStep: 1,
      agree_status: false,
      firstType: true, // 第一次進來輸入資料
      userForm: {
        chinese_last_name: null,
        chinese_first_name: null,
        preferred_name: null,
        saCode: null,
        mobile: null,
        verify: null
      },
      chinese_last_name: null,
      chinese_first_name: null,
      preferred_name: null,
      sa_code: null,
      mobileVerfityCode: null,
      verfityTotalTime: 180,
      verfityNowTime: 0,
      verfityCanClick: true,
      popup_info: null,
      pageTop: 0,
      body: document.body
    };
  },
  mounted() {
    const vm = this;
    // 檢查綁定狀態
    vm.$store.dispatch('sa_sign_up/checkBindingHandler')
      .then(() => {
        vm.$store.commit('toggleLoading', false);
      });
  },
  methods: {
    openWrongInfoModalHandler() {
      const vm = this;
      vm.body.style.position = '';
      vm.body.style.top = '';
      window.scrollTo(0, vm.pageTop);
      $('body').css('overflow', 'hidden');
      $('#wrong-info').addClass('fadeIn');
    },
    closeWrongInfoModalHandler() {
      const vm = this;
      vm.body.style.position = '';
      vm.body.style.top = '';
      window.scrollTo(0, vm.pageTop);
      $('body').css('overflow', 'scroll');
      $('#wrong-info').removeClass('fadeIn');
    },
    openModalHandler() {
      const vm = this;
      vm.body.style.position = '';
      vm.body.style.top = '';
      window.scrollTo(0, vm.pageTop);
      $('body').css('overflow', 'hidden');
      $('#pop-info').addClass('fadeIn');
    },

    closeModalHandler() {
      const vm = this;
      vm.body.style.position = '';
      vm.body.style.top = '';
      window.scrollTo(0, vm.pageTop);
      $('body').css('overflow', 'scroll');
      $('#pop-info').removeClass('fadeIn');
    },

    async nextStepHandler() {
      const vm = this;
      switch (vm.nowStep.toString()) {
      case '1':
        if (!vm.agree_status) {
          this.$swal.fire({
            icon: 'info',
            title: '請勾選同意事項'
          });
        } else {
          vm.nowStep = 2;
        }
        break;
      case '2':
        vm.mobileNumberHandler();
        break;
      case '3':
        vm.mobileVerfityHandler();
        break;
      case '4':
        vm.submitHandler();
        break;
      default:
        break;
      }
    },
    // 送出表單
    async submitHandler() {
      const vm = this;
      let isValid = true;

      if (!vm.agree_status) {
        isValid = false;
        vm.popup_info = '請同意顧問服務聲明條款';
      }
      if (vm.chinese_last_name === '' || vm.chinese_last_name === null) {
        isValid = false;
        vm.popup_info = '請填寫中文姓氏';
      }
      if (vm.chinese_first_name === '' || vm.chinese_first_name === null) {
        isValid = false;
        vm.popup_info = '請填寫中文姓名';
      }
      if (vm.preferred_name === '' || vm.preferred_name === null) {
        isValid = false;
        vm.popup_info = '請填寫顯示名字';
      }
      if (vm.sa_code === '' || vm.sa_code === null) {
        isValid = false;
        vm.popup_info = '請輸入員工編號';
      }
      if (!isValid) {
        vm.openModalHandler();
      } else {
        this.$swal.fire({
          title: '表單送出中，請稍候',
          allowOutsideClick: false,
          willOpen: () => {
            this.$swal.showLoading();
          }
        });

        // 送出並綁定
        vm.$store.dispatch('sa_sign_up/doBindingHandler', {
          chinese_last_name: vm.chinese_last_name,
          chinese_first_name: vm.chinese_first_name,
          preferred_name: vm.preferred_name,
          sa_code: vm.sa_code
        })
          .then((data) => {
            this.$swal.close();
            vm.$router.push({
              name: SA_SIGN_UP_SUCCESS,
              params: {
                mars_ba_id: data.data.mars_ba_id
              }
            });
          }).catch((res) => {
          if (res.message === '查無對應職員資料') {
            this.$swal.close();
            vm.openWrongInfoModalHandler();
          }
        });
      }
    },
    // 檢查有無填寫手機號碼
    async mobileNumberHandler() {
      const vm = this;
      const isValid = await vm.$refs.mobileNumberForm.validate();
      if (!isValid) {
        if (vm.userForm.mobile === null) {
          vm.userForm.mobile = '';
        }
        if (!vm.userForm.mobile) {
          vm.$swal.fire({
            icon: 'error',
            title: '請填寫手機號碼'
          });
        }
      } else {
        vm.countDownHandler();
        vm.nowStep = 3;
      }
    },
    // 送出手機驗證
    async mobileVerfityHandler() {
      const vm = this;
      const isValid = await vm.$refs.mobileVerfityForm.validate();
      if (!isValid) {
        if (vm.mobileVerfityCode === null) {
          vm.mobileVerfityCode = '';
        }
        if (!vm.mobileVerfityCode) {
          vm.$swal.fire({
            icon: 'error',
            title: '請填寫驗證碼'
          });
        }
      } else {
        vm.$swal.fire({
          title: '驗證中，請稍候',
          allowOutsideClick: false,
          willOpen: () => {
            this.$swal.showLoading();
          }
        });

        // 驗證簡訊驗證碼
        vm.$store.dispatch('sa_sign_up/validateSmsHandler', {
          mobile: vm.userForm.mobile,
          code: vm.mobileVerfityCode
        })
          .then(() => {
            this.$swal.close();
            vm.nowStep = 4;
          });
      }
    },
    // 檢查欄位
    validState(key) {
      const vm = this;
      if (vm.userForm[key] !== null) {
        if (key === 'mobile') {
          const MobileReg = /^(09)[0-9]{8}$/;
          return MobileReg.test(vm.userForm[key]);
        }
        if (key === 'email') {
          const EmailReg = /^[^\s]+@[^\s]+\.[^\s]{2,3}$/;
          return EmailReg.test(vm.userForm[key]);
        }
        if (key === 'verify') {
          return vm.userForm.verify === vm.$refs.VerifyComponent.varifyAnswer ? true : false;
        }
        return this.userForm[key] ? true : false;
      }
      return null;
    },
    mobileState() {
      const vm = this;
      if (vm.userForm.mobile !== null) {
        const MobileReg = /^(09)[0-9]{8}$/;
        return MobileReg.test(vm.userForm.mobile);
      }
      return null;
    },
    validverfityState() {
      const vm = this;
      if (vm.mobileVerfityCode !== null) {
        return this.mobileVerfityCode ? true : false;
      }
      return null;
    },
    // 倒數驗證碼
    countDownHandler() {
      const vm = this;
      if (!vm.verfityCanClick) return;
      // 發送驗證碼
      vm.$store.dispatch('sa_sign_up/sendSmsValidateHandler', vm.userForm.mobile)
        .then(() => {
          vm.verfityCanClick = false;
          vm.verfityNowTime = vm.verfityTotalTime;
          const clock = window.setInterval(() => {
            if (vm.verfityNowTime === 0) {
              window.clearInterval(clock);
              vm.verfityCanClick = true; // 這裡重新開啟
            } else {
              vm.verfityNowTime -= 1;
            }
          }, 1000);
        });
    },
    changeVerifyCodeHandler() {
      const vm = this;
      vm.$refs.VerifyComponent.changeVerifyCodeHandler();
    }
  }
};
</script>

<style scoped>
  .container {
    position: relative;
    z-index: 11;
    max-width: 640px;
    width: 100%;
    margin: 2.5rem auto 0;
    padding: 0 0.5rem 0;
  }
  .declare {
    border-radius: 0.7rem;
    background-color: #fff;
    height: 12rem;
    position: relative;
    margin-bottom: 3rem;
  }

  .border-black {
    border: 0.2rem solid #000;
  }

  .shadow {
    -webkit-box-shadow: 0.4rem 0.4rem 0 rgb(0 0 0 / 20%);
    box-shadow: 0.4rem 0.4rem 0 rgb(0 0 0 / 20%);
  }

  .declare_wrap {
    font-size: 0.8rem;
    padding: 0.7rem 0.7rem 0.7rem;
    overflow: auto;
    height: 100%;
    line-height: 1.2;
  }

  .declare_text {
    margin: 0;
    padding: 0;
    border: 0;
    font-size: 100%;
    font: inherit;
    vertical-align: baseline;
  }

  .top {
       background-color: #000 !important;
       width: 100%;
       border-radius: 0 0 1rem 1rem;
       position: absolute;
       top: 0;
       left: 0;
       z-index: 0;
       height: 10rem;
     }

  .declare .btn {
    position: absolute;
    font-size: 1rem;
    left: 50%;
    bottom: -1rem;
    -webkit-transform: translate(-50%, 50%);
    transform: translate(-50%, 50%);
    color: #000 !important;
  }

  .btn-ib {
    padding: 0.3rem 0.5rem;
  }

  .btn {
    border-radius: 9487px;
    font-size: 1rem;
    font-weight: 600;
    display: inline-block;
    text-align: center;
    -webkit-box-shadow: 0.13rem 0.13rem 0 rgb(0 0 0 / 20%);
    box-shadow: 0.13rem 0.13rem 0 rgb(0 0 0 / 20%);
    color: #000 !important;
    border: 0.2rem solid #000;
    cursor: pointer;
  }

  .declare .btn {
    position: absolute;
    font-size: 1.2rem;
    left: 50%;
    bottom: 0;
    -webkit-transform: translate(-50%, 50%);
    transform: translate(-50%, 50%);
  }

  .declare .btn .input_wrap {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
  }

  .declare .btn .input_icon {
    width: 2rem;
    height: 2rem;
    background-color: #fff;
    border-radius: 50%;
    margin-right: 0.4rem;
    position: relative;
  }

  .declare .btn .input_icon::after {
    display: block;
    content: "";
    position: absolute;
  }

  .declare .btn .input_icon::after {
    display: none;
    position: absolute;
    top: 50%;
    left: 50%;
    -webkit-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
    width: 1.5rem;
    height: 1.1rem;
    background-image: url(../../../assets/images/icon/check-1.png);
    background-size: 1.5rem;
    background-repeat: no-repeat;
  }

  .declare .btn .input_text {
    white-space: nowrap;
  }

  #checkbox-agree:checked ~ .input_wrap .input_icon::after {
    display: block;
  }

  span {
    display: inline-block;
  }

  input,
  select,
  textarea {
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
  }

  label {
    margin-bottom: 0;
  }

  input[type="checkbox"] {
    position: absolute;
    width: 1px;
    height: 1px;
    display: none;
    opacity: 0;
  }

  p {
    font-weight: 500;
  }

  .caption {
    font-size: 1.3rem;
    font-weight: 600;
    text-align: center;
    margin-bottom: 1.8rem;
  }

  .advisor_info {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: justify;
    -ms-flex-pack: justify;
    justify-content: space-between;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    -ms-flex-wrap: wrap;
    flex-wrap: wrap;
  }

  @media (max-width: 40em) {
    .advisor_info input:not(:first-child) {
      margin-top: 1rem;
    }
  }

  .advisor_info input:nth-child(n + 3) {
    margin-top: 1rem;
  }

  @media (max-width: 40em) {
    .advisor_info input:nth-child(n + 3) {
      margin-top: 1rem;
    }
  }

  .advisor_info .input_half {
    width: 49%;
  }

  @media (max-width: 40em) {
    .advisor_info .input_half {
      width: 100%;
    }
  }

  .popup {
    display: none;
  }

  .popup_wrap {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    min-height: 100vh;
  }

  .popup .btn_wrap {
    margin-top: 2.3rem;
  }

  #BAID-popup .btn_wrap .btn:not(:first-child) {
    margin-left: 1rem;
  }

  #agree-popup .popup_body {
    text-align: center;
    font-weight: 600;
  }

  input[type="text"] {
    border: 0;
    outline: 0;
    background-color: #eee;
    font-size: 1rem;
    padding: 0.6rem 1.2rem;
    border-radius: 9487px;
    width: 100%;
  }

  ::-webkit-input-placeholder {
    font-weight: 600;
  }

  ::-moz-placeholder {
    font-weight: 600;
  }

  :-ms-input-placeholder {
    font-weight: 600;
  }

  ::-ms-input-placeholder {
    font-weight: 600;
  }

  ::placeholder {
    font-weight: 600;
  }

  .btn-b {
    width: 100%;
    padding: 0.5rem 0;
  }

  .container .btn_wrap {
    margin-top: 2rem;
  }

  @-webkit-keyframes fadeIn {
    0% {
      opacity: 0;
    }

    100% {
      opacity: 1;
    }
  }

  @keyframes fadeIn {
    0% {
      opacity: 0;
    }

    100% {
      opacity: 1;
    }
  }

  .fadeIn {
    display: block;
    -webkit-animation-name: fadeIn;
    animation-name: fadeIn;
  }

  @-webkit-keyframes fadeOut {
    0% {
      opacity: 1;
    }

    100% {
      opacity: 0;
    }
  }

  @keyframes fadeOut {
    0% {
      opacity: 1;
    }

    100% {
      opacity: 0;
    }
  }

  .popup {
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    background-color: rgba(0, 0, 0, 0.8);
    z-index: 12;
    overflow: auto;
  }

  .popup_wrap {
    max-width: 640px;
    width: 100%;
    margin: auto;
    padding: 10rem 0;
  }

  .popup_content {
    width: 90%;
    margin: auto;
    background-color: #fff;
    padding: 4rem 1.8rem 2.3rem;
    border-radius: 1.4rem;
  }

  .popup_header_title {
    font-size: 1.5rem;
    font-weight: 600;
    text-align: center;
    margin-bottom: 0.9rem;
  }

  .popup_body {
    font-size: 1.2rem;
    line-height: 1.5;
  }

  .fadeOut {
    -webkit-animation-name: fadeOut;
    animation-name: fadeOut;
  }

  .bind_icon_wrap {
    width: 10rem;
    height: 10rem;
    background-color: #fff;
    border-radius: 50%;
    margin: 1rem auto 1.8rem;
    position: relative;
  }

  .bind_icon {
    width: 7rem;
    height: 0;
    padding-bottom: 7rem;
    background-position: center;
    background-size: cover;
    position: absolute;
    top: 50%;
    left: 50%;
    -webkit-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
  }

  .bind_icon-fail {
    background-image: url(../../../assets/images/icon/bind-fail.png);
  }

  .bind_icon-success {
    background-image: url(../../../assets/images/icon/bind-success.png);
  }

  .bind_title {
    font-size: 1.6rem;
    font-weight: 800;
    text-align: center;
    margin-bottom: 1.8rem;
  }

  .bind_text {
    font-size: 0.9rem;
    line-height: 1.5;
    font-weight: 500;
    padding: 0 1rem;
    margin-bottom: 1.8rem;
  }

  .btn_wrap {
    margin-bottom: 2.3rem;
  }
</style>
